import {defineStore} from "pinia";
import storage from "@/utils/storage";

const TAB_CACHE_KEY = "tabs";

const createDefaultState = () => ({
    editableTabsValue: "/index",
    editableTabs: [{title: "首页", path: "/index", router: {}}],
});

const loadTabsState = () => {
    const defaultState = createDefaultState();
    try {
        const cached = storage.getParse(TAB_CACHE_KEY);
        if (!cached || !Array.isArray(cached.editableTabs)) return defaultState;

        const paths = new Set();
        const editableTabs = cached.editableTabs.reduce((tabs, item) => {
            if (!item || typeof item.path !== "string" || paths.has(item.path)) return tabs;
            paths.add(item.path);
            tabs.push({title: typeof item.title === "string" ? item.title : item.path, path: item.path, router: {}});
            return tabs;
        }, []);

        if (!paths.has("/index")) editableTabs.unshift(defaultState.editableTabs[0]);
        return {
            editableTabsValue: editableTabs.some(item => item.path === cached.editableTabsValue)
                ? cached.editableTabsValue
                : "/index",
            editableTabs,
        };
    } catch (_) {
        return defaultState;
    }
};

/**
 * @description: 用于存储标签页
 */
const useTabsStore = defineStore("tabs", {
    state: () => loadTabsState(),
    /*
        // 标签页 默认值
        editableTabsValue: '/index',
        // 标签页数据
        editableTabs: [
            {
                // 标签页标题
                title: '首页',
                // url
                path: '/index',
                // 包含的菜单route信息
                router: {},
            }
        ],
    }),
    */
    actions: {
        persistTabs() {
            storage.set(TAB_CACHE_KEY, {
                editableTabsValue: this.editableTabsValue,
                editableTabs: this.editableTabs.map(({title, path}) => ({title, path})),
            });
        },
        // 添加标签页
        addTab(menuItem) {
            // 添加标签页
            if (this.editableTabs.findIndex(item => item.path === menuItem.path) === -1) {
                this.editableTabs.push({
                    title: menuItem.title,
                    path: menuItem.path,
                    router: menuItem,
                });
            }
            // 默认选中标签页
            this.editableTabsValue = menuItem.path;
        },
        // 删除一个标签页
        removeTab(path) {
            let index = this.editableTabs.findIndex(item => item.path === path);
            if (index >= 0) {
                this.editableTabs.splice(index, 1);
            }
        },
        // $reset() 会从持久化缓存恢复旧标签；关闭全部时应明确只保留首页。
        resetTabs() {
            const defaultState = createDefaultState();
            this.editableTabsValue = defaultState.editableTabsValue;
            this.editableTabs = defaultState.editableTabs;
        },

    }

})


const subscribedStores = new WeakSet();

const tabsStore = (...args) => {
    const store = useTabsStore(...args);
    if (!subscribedStores.has(store)) {
        store.$subscribe(() => store.persistTabs(), {detached: true});
        subscribedStores.add(store);
    }
    return store;
};

export default tabsStore
